import packageJson from '../../../package.json';

export const VERSION = packageJson.version;
